import React, {Component} from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Builder} from "../../../utils/lists/ListProcessor";
import CaptureGuaranteesView from "./CaptureGuaranteesView";
import {CaptureGuaranteesService} from "../../../service/ptt/captureGuarantees/CaptureGuaranteesService";
import {numberWithCommaDataTableTemplate} from "../../../utils/formatters/Numbers";
import {dateDDMMYYDataTableTemplate} from "../../../utils/formatters/Date";
import ContextMenu from "../../../components/contextMenu";
import {
    ADD_POSITION_ROUTE,
    CAPTURE_GUARANTEES_ROUTE,
    EDIT_POSITION_ROUTE
} from "../../../utils/constants/RoutesConstants";
import ConfirmationMessage from "../../../components/confirmationMessage";
import {Growl} from "primereact/growl";

export default class CaptureGuaranteesContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     *              Trae el elemento de la pantalla anterior para editar.
     */
    constructor(props) {
        super(props);
        this.captureGuaranteesService = new CaptureGuaranteesService();
        this.getDataGuaranteePosition = this.getDataGuaranteePosition.bind(this);
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        }

        this.state = {
            dataGuaranteePosition: this.getDataGuaranteePosition(),
            isLoading: true,
            expanded: false,
        };
        this.captureGuaranteeActionTemplate = this.captureGuaranteeActionTemplate.bind(this);
        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
        this.redirectAddPosition = this.redirectAddPosition.bind(this);
        this.redirectEditPosition = this.redirectEditPosition.bind(this);
        this.deletePosition = this.deletePosition.bind(this);
        this.expandReduceAll = this.expandReduceAll.bind(this);
        this.loading = this.loading.bind(this);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    /**
     * Función que hace una consulta al back para obtener la lista de
     * las posiciones y colocar la lista en la tabla de la pantalla
     * principal
     */
    getDataGuaranteePosition() {
        this.loading();
        this.captureGuaranteesService.getGuaranteePosition()
            .then((resp) => {
                let builder = new Builder();
                builder.groupList(resp, 'cuenta');
                this.setState({
                    dataGuaranteePosition: builder.mapObjects,
                    isLoading: false,
                });
            });
    }

    /**
     * Función que maneja qué fila fue seleccionada para expandirla
     * y mostrar la lista de cuentas que contiene.
     * @param event Evento que trae la información de la opción expandida.
     */
    handleToggle = (event) => {
        this.setState(
            {
                expandedRows: event.data,
            })
    };

    /**
     * Función que maneja la selección de una fila pero esta vez es de la opción
     * que se seleccionó en la lista dentro se las cuentas para editarla o
     * eliminarla
     * @param event Evento que trae la información de la opción seleccionada.
     */
    handleSelectedRow = (event) => {
        this.setState(
            {
                selectedPosition: event.value,
            })
    }

    /**
     * Función que realiza un template de las listas que se contienen en las emisoras
     * Realiza una tabla donde las muestra.
     * @param data Información de la lista contenida en cada renglón principal.
     * @returns {*} Template para cada una de las cuentas
     */
    rowExpansionTemplate(data) {
        const itemsAccount = data.items;
        return (
            <div className="p-grid p-fluid" style={{padding: '1em'}}>
                <DataTable
                    value={itemsAccount}
                    responsive={true}
                    selectionMode="single"
                    onSelectionChange={this.handleSelectedRow.bind(this)}
                    resizableColumns={true}
                    columnResizeMode={"fit"}>
                    <Column field="emisora" header="Emisora" style={{textAlign: 'left'}}
                            sortable={true}/>
                    <Column field="tipoValor" header="Tipo valor" style={{textAlign: 'left'}}
                            sortable={true}/>
                    <Column field="posicion" header="Posición Disponible" style={{textAlign: 'right'}}
                            body={numberWithCommaDataTableTemplate} sortable={true}/>
                    <Column field="disponibleGarantias" header="Disponible para Garantizar" style={{textAlign: 'right'}}
                            body={numberWithCommaDataTableTemplate} sortable={true}/>
                    <Column field="garantiasAsignadas" header="Garantías Asignadas" style={{textAlign: 'right'}}
                            body={numberWithCommaDataTableTemplate} sortable={true}/>
                    <Column field="garantiasPosturas" header="Garantías posturas" style={{textAlign: 'right'}}
                            body={numberWithCommaDataTableTemplate} sortable={true}/>
                    <Column field="disponiblePrestable" header="Total a prestar" style={{textAlign: 'right'}}
                            body={numberWithCommaDataTableTemplate} sortable={true}/>
                    <Column field="fechaVence" header="Fecha Vence" style={{textAlign: 'left'}}
                            body={dateDDMMYYDataTableTemplate} sortable={true}/>
                    <Column field="diasVence" header="Días Vence" style={{textAlign: 'right'}}
                            body={numberWithCommaDataTableTemplate} sortable={true}/>
                    <Column field="bursatilidad" header="Bursatilidad" style={{textAlign: 'left'}}
                            sortable={true}/>
                    <Column header="Acciones"
                            body={this.captureGuaranteeActionTemplate}
                            style={{textAlign: 'center', width: '8em'}}/>
                </DataTable>
            </div>
        );
    }

    /**
     * Función que contruye un template para la última columna de la tabla
     * donde se muestra un menú contextual con las opciones editar y eliminar.
     * @returns {html} Menú contextual (Editar, Eliminar)
     */
    captureGuaranteeActionTemplate(rowData, column) {
        let optionsMenu = [
            {label: "Editar", action: this.redirectEditPosition},
            {label: "Eliminar", action: this.confirmationRef.openConfirmationMessage},
        ];
        return (
            <ContextMenu menuOptions={optionsMenu}/>
        );
    }

    /**
     * Función que redirecciona a la pantalla de editar
     */
    redirectEditPosition() {
        this.props.history.push({
            pathname: EDIT_POSITION_ROUTE,
            state: {
                returnPath: CAPTURE_GUARANTEES_ROUTE,
                selectedPosition: this.state.selectedPosition,
            },
        });
    }

    /**
     * Función que toma la posición seleccionada y la elimina de la tabla.
     * Para ello hace una petición al servicio CaptureGuaranteesService
     */
    deletePosition() {
        if (this.state.selectedPosition) {
            this.captureGuaranteesService.deletePosition(
                this.state.selectedPosition.idEmision, this.state.selectedPosition.cuenta)
                .then(res => {
                    if (res.message && res.message === 'Success') {
                        this.growl.show({
                            severity: 'success', summary: 'Éxito.',
                            detail: 'Se ha actualizado su solicitud con éxito'
                        });
                    } else if (res.error && res.error !== '') {
                        this.growl.show({
                            severity: 'error', summary: 'Error.',
                            detail: res.error
                        });
                    }
                    this.getDataGuaranteePosition();
                });
        } else {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: 'No se pudo eliminar elemento. Posicion no seleccionada.'
            });
        }
    }

    /**
     * Función que se encarga de contraer y expandir los grupos de
     * instituciones en el dataTable
     */
    expandReduceAll() {
        if (this.state.expanded) {
            this.setState({
                expandedRows: [],
                expanded: false,
            });
        } else {
            this.setState({
                expandedRows: this.state.dataGuaranteePosition,
                expanded: true,
            });
        }
    }

    /**
     * Función que redirecciona a la pantalla de agregar posición
     */
    redirectAddPosition() {
        this.props.history.push({
            pathname: ADD_POSITION_ROUTE,
            state: {
                returnPath: CAPTURE_GUARANTEES_ROUTE,
            },
        });
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        this.confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                            invisible={true}
                                            legend="¿Desea eliminar la posición seleccionada?"
                                            action={this.deletePosition}/>;
        const {dataGuaranteePosition, expandedRows, isLoading} = this.state;
        return (
            <CaptureGuaranteesView dataGuaranteePosition={dataGuaranteePosition}
                                   expandedRows={expandedRows}
                                   isLoading={isLoading}
                                   messagesGrowl={messagesGrowl}
                                   confirmationMsg={this.confMsg}
                                   redirectAddPosition={this.redirectAddPosition}
                                   handleToggle={this.handleToggle}
                                   rowExpansionTemplate={this.rowExpansionTemplate}
                                   expandReduceAll={this.expandReduceAll}
                                   getDataGuaranteePosition={this.getDataGuaranteePosition}
            />
        );
    }
}
